import styled from 'styled-components';
import { ClickableTextMixin } from 'components/base/common-styles';
import { getColor } from 'common/constants/_colors';
const { SIZES } = require('common/constants/sizes');

export const StyledLink = styled.a`
  color: ${getColor('dodgerBlue')};
  text-decoration: none;
  &:hover {
    cursor: pointer;
    opacity: 0.7;
  }
`;

export const StyledCell = styled.div`
  font-size: ${SIZES.medium};
  display: flex;
  align-items: center;
  height: 100%;
  ${ClickableTextMixin}
`;

export const StyledListCell = styled(StyledCell)`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
`;

export const StyledListCellRow = styled.div`
  padding: 0.3rem;
  &:hover {
    cursor: pointer;
    opacity: 0.7;
  }
`;
